import React, { useState, useEffect } from 'react';
import { Button, Card, Table, Modal, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import apiClient from '../services/apiClient';

const QuestionTypes = () => {
    const [types, setTypes] = useState([]);
    const [newTypeName, setNewTypeName] = useState('');
    const [newTypeDescription, setNewTypeDescription] = useState('');

    // Inline düzenleme için gerekli state'ler
    const [editingTypeId, setEditingTypeId] = useState(null);
    const [editName, setEditName] = useState('');
    const [editDescription, setEditDescription] = useState('');

    // Silme işlemi için modal state
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteCandidate, setDeleteCandidate] = useState(null);

    useEffect(() => {
        fetchTypes();
    }, []);

    // Tüm Soru Tiplerini Listeleme
    const fetchTypes = async () => {
        try {
            const { data } = await apiClient.post('/question/getallquestiontypes');
            setTypes(data.Data.Items);

        } catch (err) {
            toast.error('Soru tipleri yüklenirken hata oluştu!');
        }
    };

    // EKLE
    const handleAdd = async () => {
        if (!newTypeName) return;
        try {
            var resp = await apiClient.post('/question/addquestiontype', {
                name: newTypeName,
                description: newTypeDescription,
            });
            if (resp.data.Status !== true) {
                toast.error(resp.data.Message + ' ' + resp.data.MessageCode);
                return;
            }
            toast.success(resp.data.Message + ' ' + resp.data.MessageCode);


            setNewTypeName('');
            setNewTypeDescription('');
            fetchTypes();
        } catch (err) {
            toast.error('Soru tipi eklenirken hata oluştu!');
        }
    };

    // DÜZENLE'ye tıklayınca seçili satırı editing moduna al
    const handleEdit = (type) => {
        setEditingTypeId(type.id);
        setEditName(type.name || '');
        setEditDescription(type.description || '');
    };

    // GÜNCELLE (burada 'POST' veya 'PUT' – backend ne kabul ediyorsa)
    const handleUpdate = async (id) => {
        try {
            var resp = await apiClient.post('/question/updatequestiontype', {
                id,
                name: editName,
                description: editDescription
            });
            if (resp.data.Status !== true) {
                toast.error(resp.data.Message + ' ' + resp.data.MessageCode);
                return;
            }
            toast.success(resp.data.Message + ' ' + resp.data.MessageCode);

            setEditingTypeId(null);
            setEditName('');
            setEditDescription('');
            fetchTypes();
        } catch (err) {
            console.error(err);
            toast.error('Güncelleme sırasında hata oluştu!');
        }
    };

    // SİLME (Modal açılışı)
    const handleDeleteModal = (type) => {
        setDeleteCandidate(type);
        setShowDeleteModal(true);
    };

    // Modal'da gerçekten silme onaylanırsa
    const handleConfirmDelete = async () => {
        if (!deleteCandidate) return;
        try {
            var resp = await apiClient.post('/question/deletequestiontype', null, { params: { Id: deleteCandidate.id } });
            if (resp.data.Status !== true) {
                toast.error(resp.data.Message + ' ' + resp.data.MessageCode);
                return;
            }
            toast.success(resp.data.Message + ' ' + resp.data.MessageCode);

            setShowDeleteModal(false);
            setDeleteCandidate(null);
            fetchTypes();
        } catch (err) {
            console.error(err);
            toast.error('Silme sırasında hata oluştu!');

        }
    };

    // Modal iptali
    const handleCancelDelete = () => {
        setShowDeleteModal(false);
        setDeleteCandidate(null);
    };

    // Düzenleme modunu iptal
    const handleCancelEdit = () => {
        setEditingTypeId(null);
        setEditName('');
        setEditDescription('');
    };

    return (
        <Card>
            <Card.Header>
                <h4 className="mb-0">Soru Tipleri Yönetimi</h4>
            </Card.Header>

            <Card.Body>
                {/* Yeni Soru Tipi Ekleme Alanı */}
                <div className="mb-4" style={{ maxWidth: '600px' }}>
                    <div className="row g-2">
                        <div className="col-md-5">
                            <Form.Control
                                type="text"
                                placeholder="Soru Tipi Adı"
                                value={newTypeName}
                                onChange={(e) => setNewTypeName(e.target.value)}
                            />
                        </div>
                        <div className="col-md-5">
                            <Form.Control
                                type="text"
                                placeholder="Açıklama"
                                value={newTypeDescription}
                                onChange={(e) => setNewTypeDescription(e.target.value)}
                            />
                        </div>
                        <div className="col-md-2">
                            <Button variant="success" className="w-100" onClick={handleAdd}>
                                Ekle
                            </Button>
                        </div>
                    </div>
                </div>

                {/* Tablo */}
                <Table bordered hover responsive>
                    <thead className="table-light">
                        <tr>
                            <th style={{ width: '200px' }}>ID</th>
                            <th style={{ width: '180px' }}>Soru Tipi Adı</th>
                            <th style={{ width: '400px' }}>Soru Tipi Açıklama</th>
                            <th style={{ width: '150px' }}>İşlem</th>
                        </tr>
                    </thead>
                    <tbody>
                        {types.map((type) => (
                            <tr key={type.id}>
                                <td>{type.id}</td>
                                <td>
                                    {editingTypeId === type.id ? (
                                        <Form.Control
                                            type="text"
                                            value={editName}
                                            onChange={(e) => setEditName(e.target.value)}
                                        />
                                    ) : (
                                        type.name
                                    )}
                                </td>
                                <td>
                                    {editingTypeId === type.id ? (
                                        <Form.Control
                                            type="text"
                                            value={editDescription}
                                            onChange={(e) => setEditDescription(e.target.value)}
                                        />
                                    ) : (
                                        type.description
                                    )}
                                </td>
                                <td>
                                    {editingTypeId === type.id ? (
                                        <>
                                            <Button
                                                variant="primary"
                                                size="sm"
                                                className="me-2"
                                                onClick={() => handleUpdate(type.id)}
                                            >
                                                Kaydet
                                            </Button>
                                            <Button variant="secondary" size="sm" onClick={handleCancelEdit}>
                                                İptal
                                            </Button>
                                        </>
                                    ) : (
                                        <>
                                            <Button
                                                variant="warning"
                                                size="sm"
                                                className="me-2"
                                                onClick={() => handleEdit(type)}
                                            >
                                                Düzenle
                                            </Button>
                                            <Button
                                                variant="danger"
                                                size="sm"
                                                onClick={() => handleDeleteModal(type)}
                                            >
                                                Sil
                                            </Button>
                                        </>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Card.Body>

            {/* Silme Onayı Modal'ı */}
            <Modal show={showDeleteModal} onHide={handleCancelDelete} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Soru Tipi Sil</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        <strong>{deleteCandidate?.name}</strong> adlı soru tipini silmek
                        istediğinize emin misiniz?
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCancelDelete}>
                        Vazgeç
                    </Button>
                    <Button variant="danger" onClick={handleConfirmDelete}>
                        Evet, sil!
                    </Button>
                </Modal.Footer>
            </Modal>
        </Card>
    );
};

export default QuestionTypes;